module.exports = __webpack_public_path__ + "static/img/contant_4.4d994b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_4/contant_4.jpg
// module id = vTKH
// module chunks = 0